module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image2_dochimom-6dafc24794ecd7dab776664ebf63301f.png";